import type { NextPage, GetServerSidePropsContext } from 'next';
import TheProduct from '@elem/compPage/delta-3-air-series-portable-power-station/pages/product';
import { ProductProvider } from '@elem/compPage/delta-3-air-series-portable-power-station/ProductProvider';
import { IPageStatus } from '@elem/compPage/delta-3-air-series-portable-power-station/config/IPageStatus';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import seoconfig from '@/seoconfig/delta-3-air-series-portable-power-station';
import { redirectTo404 } from '@/utils';
import dynamic from 'next/dynamic';

// 路由跳转白名单
const whiteLocaleList = ['ph'];
const Delta3AirSeries: NextPage = ({ SEO, timeLine, pageStatus, isLogin }: any) => {
    const { t } = useLang('Delta3AirSeries');
    const { locale } = getLocal();
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    const initState = {
        timeLine,
        pageStatus,
        isLogin,
    };

    return (
        <PageLayout theme="white" isNoFixed>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={whiteLocaleList} locale={locale} pathname={seoconfig.url} />
            <GtmPageLoad />
            <ProductProvider state={initState}>
                <TheProduct />
            </ProductProvider>
        </PageLayout>
    );
};

export default Delta3AirSeries;

export async function getServerSideProps({ locale, query, req }: GetServerSidePropsContext) {
    console.log(locale, query);
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/delta-3-air-series-portable-power-station/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/delta-3-air-series-portable-power-station/config/times/ph.js`);
    }
    const timeLine = data.formal.timeLine || null; // 代码保存的时间线
    // 时间节点判断 正式环境未开始重定向404
    const time = new Date().getTime(); // 服务器时区北京时区

    let currentTime = time;
    let pageStatus = currentTime >= timeLine.statusA.start ? IPageStatus.statusA : '';

    if (debug && !_timer) {
        if (debug === IPageStatus.statusA) {
            pageStatus = IPageStatus.statusA;
        } else if (debug === IPageStatus.statusB) {
            pageStatus = IPageStatus.statusB;
        } else {
            return redirectTo404();
        }
    }

    if (_timer) {
        currentTime = new Date(`${_timer} GMT+8`).getTime();
    }

    if (timeLine) {
        if (timeLine.statusB?.start && currentTime >= timeLine.statusB.start) {
            pageStatus = IPageStatus.statusB;
        } else if (currentTime >= timeLine.statusA.start) {
            pageStatus = IPageStatus.statusA;
        } else {
            return redirectTo404();
        }
    }

    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    return {
        props: {
            timeLine: timeLine,
            pageStatus: pageStatus,
            isLogin,
        },
    };
}
